export const isoCountryCode = () => Promise.resolve('US');
